module.exports = __webpack_public_path__ + "img/rotation-updated-icon.b3b24dc8.svg";